import { render, staticRenderFns } from "./TestDriveBookingComponent.vue?vue&type=template&id=1bd3246f"
import script from "./TestDriveBookingComponent.vue?vue&type=script&lang=ts"
export * from "./TestDriveBookingComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports